var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3364 2H2.66976C1.93643 2 1.33643 2.6 1.33643 3.33333V10.6667C1.33643 11.4 1.93643 12 2.66976 12H4.66976C4.30309 12.3667 4.00309 12.58 4.00309 13.06C4.00309 13.58 4.42309 14 4.94309 14H11.0564C11.5764 14 11.9964 13.58 11.9964 13.06C11.9964 12.58 11.7031 12.3733 11.3298 12H13.3298C14.0631 12 14.6631 11.4 14.6631 10.6667V3.33333C14.6698 2.6 14.0698 2 13.3364 2ZM13.3364 10.6667H2.66976V3.33333H13.3364V10.6667Z",
    fill: "#79C8B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3364 2H2.66976C1.93643 2 1.33643 2.6 1.33643 3.33333V10.6667C1.33643 11.4 1.93643 12 2.66976 12H4.66976C4.30309 12.3667 4.00309 12.58 4.00309 13.06C4.00309 13.58 4.42309 14 4.94309 14H11.0564C11.5764 14 11.9964 13.58 11.9964 13.06C11.9964 12.58 11.7031 12.3733 11.3298 12H13.3298C14.0631 12 14.6631 11.4 14.6631 10.6667V3.33333C14.6698 2.6 14.0698 2 13.3364 2ZM13.3364 10.6667H2.66976V3.33333H13.3364V10.6667Z",
    fill: "url(#paint0_linear_127_12318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_12318",
    x1: 12.1644,
    y1: 12,
    x2: 5.19517,
    y2: 4.66462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.fd07ddb6311304fe1fd5b9a4750d8d24.svg";
export { ForwardRef as ReactComponent };